import React from "react";
// import Deliverynote from "./Deliverynote";
import { useLocation } from 'react-router-dom';
import Header from "../../../../Components/Header";
import Asnform  from "./Create";
import { Helmet } from "react-helmet";

const AsnCreate = () => {
  const location = useLocation();
  const { picklist_id, is_new } = location.state || {};

  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
        <title>Create ASN</title>
      </Helmet>
      <Header/>
      <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
        <Asnform  />

      </div>
    </div>

  );
};

export default AsnCreate;
